import type { AutoDiagLocale } from "@/locales/fr/auto-diag";

import {
  EAutoDiagDeviceInfoEnergyManager,
  EAutoDiagDiagnosticTestResult,
} from "@/types/backoffice/dto/autodiag/auto-diag-dto.ts";

const autoDiagLocale: AutoDiagLocale = {
  autoDiag: {
    realtimeDiagnostic: "Realtime diagnostic",
    warningMultipleDiags: "Do not run multiple diagnostics at the same time. You must wait for the first one to finish",
    warningPreTest:
      'Before any diagnosis, make sure that all the circuit breakers on the electrical panel are ON (or in raised position) and click on "Synchronize MyV programming"',
    techInstructionsPreBtn: "If the issue is not resolved after diagnosis, ",
    techInstructionsBtn: "please provide instructions for the technician",
    syncMyVProgrammingButton: "Synchronize MyV programming",
    diagnostic: {
      headers: {
        deviceName: "Device name",
        result: "Result",
        date: "Date",
        energyManager: "Energy manager",
        myvProgram: "MyV Program",
        synchronization: "Synchronisation",
        launchDiag: "Launch diag",
        hint: "Help",
        actions: "Actions",
      },
      test: {
        [EAutoDiagDiagnosticTestResult.OK]: "Pilotage OK",
        [EAutoDiagDiagnosticTestResult.NOK_NO_POWER]: "Appliance: No power",
        [EAutoDiagDiagnosticTestResult.NOK_NO_MODULATION]: "Appliance: No modulation",
        [EAutoDiagDiagnosticTestResult.NOK_UNREACHABLE]: "Modulator: Connexion failure",
        [EAutoDiagDiagnosticTestResult.NOK_DEVICE_UNKNOWN]: "Modulator: Connexion failure",
        [EAutoDiagDiagnosticTestResult.FAILED_BACKEND]: "Failure Voltalis Infra",
      },
      energyManager: {
        [EAutoDiagDeviceInfoEnergyManager.HAS_ENERGY_MANAGER]: "Detected",
        [EAutoDiagDeviceInfoEnergyManager.NO_ENERGY_MANAGER]: "Not Detected",
        [EAutoDiagDeviceInfoEnergyManager.ERROR_INFRA_VOLTALIS]: "Failure Voltalis Infra",
      },
      conformity: {
        notConform: "Non conforme",
        conform: "Conforme",
        error: "Failure Voltalis Infra",
      },
    },
  },
};

export default autoDiagLocale;
